const __WEBPACK_NAMESPACE_OBJECT__ = require("rxjs/add/operator/scan");